var _g, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_492_12978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0391 17.1817V20.8936H16.823V27.3895H20.535V20.8936H23.3189L24.2469 17.1817H20.535V15.3257C20.535 15.0796 20.6327 14.8436 20.8068 14.6695C20.9808 14.4955 21.2168 14.3977 21.4629 14.3977H24.2469V10.6858H21.4629C20.2324 10.6858 19.0522 11.1746 18.182 12.0448C17.3119 12.9149 16.823 14.0951 16.823 15.3257V17.1817H14.0391Z",
    fill: "#37994F"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.6788,
    cy: 19.0373,
    r: 17.8637,
    stroke: "#37994F",
    strokeWidth: 1.39198
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_492_12978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.2716,
    height: 22.2716,
    fill: "white",
    transform: "translate(7.54297 7.90125)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e43ae1615a03109918279a785476ab59.svg";
export { ForwardRef as ReactComponent };